import React from 'react'
import { join } from 'path'
import { Link } from 'react-navi'
import styles from './Pagination.module.css'

function Pagination({ blogRoot, pageCount, pageNumber }) {
  return (
    <small className={styles.Pagination}>
      {
        pageNumber !== 1 &&
        <Link
          className={styles.previous}
          href={join(blogRoot, 'pagina', String(pageNumber - 1))}>
          ← Anterior
        </Link>
      }
      <span className={styles.pages}>
        {' '}Página <span className={styles.current}>{pageNumber}</span>/<span className={styles.count}>{pageCount}</span>{' '}
      </span>
      {
        pageNumber < pageCount &&
        <Link
          className={styles.next}
          href={join(blogRoot, 'pagina', String(pageNumber + 1))}>
          Próxima →
        </Link>
      }
    </small>
  )
}

export default Pagination